import { create } from "zustand";

export interface PartnerConfig {
  slug: string;
  name: string;
  logo_url: string;
  icon_url: string;
  primary_color: string;
  accent_color: string;
  background_pattern_url: string;
  sidebar_bg: string;
  support_email: string;
  support_whatsapp: string;
  default_country: string;
  /** Palette preset: "" is Pulse's own, "ledger" is Clerk's green. */
  theme: string;
  /** The partner's registered company, for /privacy and /terms. */
  legal_name: string;
  company_number: string;
  address: string;
  ico_number: string;
  /** Data protection officer and phone, shown on the UK privacy policy when set. */
  dpo: string;
  phone: string;
}

/** The app's own name — the same on every instance, a partner's included, as
 *  Clerk is Clerk on theirs. The partner (`name`) is the owner, not the product. */
export const APP_NAME = "Pulse";

/** The slug of Faxter's own instance; anything else is a partner's. */
export const DEFAULT_PARTNER_SLUG = "pulse";

interface PartnerState {
  config: PartnerConfig | null;
  loaded: boolean;
  fetchConfig: () => Promise<void>;
}

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

export const usePartnerStore = create<PartnerState>((set, get) => ({
  config: null,
  loaded: false,
  fetchConfig: async () => {
    if (get().loaded) return;
    try {
      const res = await fetch(`${API_URL}/api/v1/partner`);
      if (res.ok) {
        const config: PartnerConfig = await res.json();
        set({ config, loaded: true });
      } else {
        set({ loaded: true });
      }
    } catch {
      set({ loaded: true });
    }
  },
}));
